import { takeLatest, all, call, put } from 'redux-saga/effects';

import { SolidMerchantDataResponse } from 'api/types/payment';
import api from 'api';

import { setIsMerchantLoading, solidValidate, setSolidMerchantData, initSolidPayment } from './actions';
import { notifyError } from '../notifications/actions';
import { handleErrorAction } from '../errors/actions';

import { INIT_SOLID_PAYMENT, SOLID_POST_INIT } from './actionTypes';

import { DEFAULT_COUNTRY } from 'constants/user';
import { DEFAULT_CURRENCY } from 'constants/currency';

function* getSolidMerchantData({ payload }: ReturnType<typeof initSolidPayment>) {
    try {
        yield put(setIsMerchantLoading(true));

        const response: SolidMerchantDataResponse = yield call(api.payments.getSolidMerchantData, {
            payment_method: 1,
            country: payload.country || DEFAULT_COUNTRY,
            currency: payload.currency || DEFAULT_CURRENCY,
            price: payload.price,
            product_code: payload.productCode,
            product_type: payload.productCodeType,
            order_type: 'fee_charge',
            subscription_id: payload.subscriptionId,
        });

        yield put(setSolidMerchantData(response));
        yield put(setIsMerchantLoading(false));
    } catch (error) {
        yield put(handleErrorAction(error));
        notifyError('initPayment error');
    }
}

function* handleSolidValidate({ payload }: ReturnType<typeof solidValidate>) {
    try {
        yield call(api.payments.solidPostInit, payload);
    } catch (error) {
        yield put(handleErrorAction(error));
        notifyError('postInit error');
    }
}

export default function* watchPayment() {
    yield all([takeLatest(INIT_SOLID_PAYMENT, getSolidMerchantData)]);
    yield all([takeLatest(SOLID_POST_INIT, handleSolidValidate)]);
}
